import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import moment from 'moment';

import { ScreenFieldModel } from '@models/module/fields/main';
import { DataCard } from '@models/module/main';
import { DataListViewAction } from '@models/module/main/dataListViewAction';
import { CalendarTileDoc } from '@module-instance/calendar/calendar.model';
import { DataCardViewComponent } from '@module-instance/data-card/data-card-view/data-card-view.component';
import { DataCardsViewService } from '@module-instance/data-card/data-cards-view/data-cards-view.service';
import { DropdownActionsEnum } from '@shared/consts';
import { CipoDialogModule } from '@shared/modules';
import { BREAKPOINTS_MEDIA_QUERY } from 'src/app-breakpoints.module';

export const CalendarDialogDocDetailPrefix: string = 'calendar-diaog-doc-detail';
export const CalendarDialogDocDetailInnerWidth: number = 600;
export const CalendarDialogDocDetailOuterWidth: number = 648;
export const CalendarDialogDocDetailInnerHeight: number = 250;
export const CalendarDialogDocDetailOuterHeight: number = 335;

@Component({
  selector: 'app-calendar-dialog-doc-detail',
  templateUrl: './calendar-dialog-doc-detail.component.html',
  styleUrls: ['./calendar-dialog-doc-detail.component.scss'],
  imports: [CommonModule, MatMenuModule, CipoDialogModule, DataCardViewComponent],
})
export class CalendarDialogDocDetailComponent implements OnInit {
  card: DataCard;
  actionsFiltered: DataListViewAction[];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      doc: CalendarTileDoc;
      screenFields: ScreenFieldModel[];
      actions: DataListViewAction[];
    },
    private dataCardsViewService: DataCardsViewService,
    private dialog: MatDialog,
    breakpointObserver: BreakpointObserver,
  ) {
    breakpointObserver.observe([BREAKPOINTS_MEDIA_QUERY.lt_md]).subscribe(_ => {
      this.minWidth = 'inherit';
      this.maxWidth = 'inherit';
    });
  }

  ngOnInit(): void {
    this.card = this.dataCardsViewService.getDataCard(
      this.data.screenFields,
      this.data.doc.ref,
      this.data.doc.currency,
    );

    if ((this.data.actions || []).length && this.card !== undefined) {
      this.actionsFiltered = (this.data.actions || []).filter(
        a => a.alwaysOnRow === true && a.condition !== undefined && a.condition(this.card),
      );
    } else {
      this.actionsFiltered = [];
    }
  }

  @HostBinding('style.min-width') minWidth = `${CalendarDialogDocDetailInnerWidth}px`;
  @HostBinding('style.max-width') maxWidth = `${CalendarDialogDocDetailInnerWidth}px`;

  get detailContentMaxHeight(): number {
    return CalendarDialogDocDetailInnerHeight;
  }

  get datetime(): string {
    const dt = moment(this.data.doc.ref.date);
    const isMidnight = dt.isSame(dt.clone().startOf('day'));
    return dt.format(isMidnight ? 'LL' : 'LLL');
  }

  actionsMenuClick($event: Event) {
    $event.stopPropagation();
  }

  actionClick(action: DataListViewAction) {
    if (action.click) {
      this.dialog.closeAll();
      action.click(this.data.doc.ref);
    }
  }

  cardViewClick() {
    const clickableActionTypes = [DropdownActionsEnum.VIEW.toString(), DropdownActionsEnum.EDIT.toString()];
    const action = this.actionsFiltered.find(a => clickableActionTypes.includes(a.actionType));
    if (action) {
      this.actionClick(action);
    }
  }
}
